import { render, staticRenderFns } from "./MenuConversation.vue?vue&type=template&id=a516918e&scoped=true"
import script from "./MenuConversation.vue?vue&type=script&lang=js"
export * from "./MenuConversation.vue?vue&type=script&lang=js"
import style0 from "./MenuConversation.vue?vue&type=style&index=0&id=a516918e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a516918e",
  null
  
)

export default component.exports